RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const Layout = views.Layout = RivalIQ.views.LayoutView.mixin({
        template: '#dashboardLayoutTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        childView: App.views.Widgets,
        sectionClassName: 'widgets-region',

        triggers: {
            'click .x-view-more': 'view:more'
        },

        regions: {
            actions: '.dashboard-actions',
            regionContainer: '.dashboard-regions'
        },

        initialize: function () {
            const me = this;
            me.widgetRegions = me._createRegions();
        },

        getCollection: function () {
            const me = this;
            return me.getOption('collection');
        },

        onBeforeRenderLoaded: function () {
            const me = this;

            // this is here to trigger the loadData on the children; this lets them be in the cacheLayer buffer
            // when the page loads (it's necessary as this curation layout has a loadData, which would otherwise
            // result in the child views being rendered after the cacheLayers are flushed).
            me.showChildren();
        },

        onRender: function () {
            const me = this;

            me.showChildren();
        },

        showChildren: function () {
            const me = this;

            me.getCollection().each(function (widget) {
                const region = widget.getRegion();
                if (region && me.widgetRegions.cache[region]) {
                    me.widgetRegions.cache[region].add(widget);
                }
            });

            me.triggerMethod('before:regions:show');

            if (!me.widgetRegions.isDestroyed) {
                me.regionContainer.show(me.widgetRegions);
            }
        },

        getImmediateLoadingChildren: function () {
            const me = this;

            return _.map(me.getSections(), function (section) {
                return section.widgets.currentView;
            });
        },

        refresh: _.noop,

        getRegionCollection: function (name) {
            const me = this;
            return me.widgetRegions.cache[name];
        },

        getRegionView: function (name) {
            const me = this;

            const section = _.find(me.getSections(), function (section) {
                return section.model.get('name') === name;
            });

            if (section) {
                return section.widgets.currentView;
            }

            return null;
        },

        getSections: function () {
            const me = this;
            const children = _.get(me, 'widgetRegions.children', []);
            return children.reduce(function (sections, regions) {
                return sections.concat(regions.children.toArray());
            }, []);
        },

        getConfig: function () {
            const me = this;
            return me.getOption('config');
        },

        /**
         * Creates regions from a config to an element.
         */
        _createRegions: function () {

            const cache = {};

            const layout = this;

            const Section = RivalIQ.views.LayoutView.extend({
                regions: {
                    widgets: {
                        selector: '.widgets-region',
                        regionClass: Marionette.Dashboard.views.LoadingRegion
                    }
                },

                className: function () {

                    const me = this;
                    const model = me.model;
                    return _.compact([me.getClassNames(model.get('sizes')), model.get('className')]).join(' ');
                },

                template: function (data) {

                    if (data && data.templateFn) {
                        return data.templateFn(data);
                    }

                    const html = $.tagHtml('div', {
                        class: layout.sectionClassName
                    });

                    return _.template(html);
                },

                getClassNames: function (sizes) {
                    sizes = sizes || {
                        sm: 12
                    };
                    return _.map(sizes, function (cols, size) {

                        return ['col', size, cols].join('-');
                    }).join(' ');
                },

                initialize: function () {

                    const me = this;
                    const model = me.model;
                    const name = model.get('name').toLowerCase();
                    const collection = (me.collection = cache[name]);
                    collection.each(me.setWidgetClassName, me);

                    _.extend(me, _.pick(layout.options, 'curation'));
                },

                onRender: function () {

                    const me = this;
                    let model = me.model;
                    const itemSizes = model.get('itemSizes');

                    // Hide if region has no elements to prevent empty region
                    // padding from taking up space
                    if (!me.collection.length) {
                        me.$el.addClass('hide');
                    } else {
                        me.$el.removeClass('hide');
                    }

                    me.startAsyncRender();

                    const attributes = {
                        page: me.model.get('page')
                    };

                    if (itemSizes) {
                        attributes.className = 'row';
                    }

                    model = (me.curation ? me.curation : me.model);

                    let WidgetsView = me.model.get('view') || layout.childView;
                    if (me.model.get('childWrapper')) {
                        WidgetsView = extendWidgetViewWithChildWrapper(me.model.get('childWrapper'), WidgetsView);
                    }

                    window.requestAnimationFrame(function () {
                        if (me.isDestroyed) {
                            return;
                        }

                        me.widgets.show(new WidgetsView({
                            collection: me.collection,
                            dashboardModel: layout.options.dashboardModel
                        }), {
                            parentLoadingView: layout._parentLoadingView
                        });

                        me.stopAsyncRender();
                    });
                },

                getWidgetsView: function (child) {
                    const me = this;
                    return child.get('view') || me.widgetsView;
                },

                setWidgetClassName: function (widget) {
                    const me = this;
                    const model = me.model;

                    const classNames = [widget.className];

                    const itemSizes = model.get('itemSizes');
                    if (itemSizes) {
                        classNames.push(me.getClassNames(itemSizes));
                    }

                    if (me.model.has('childClassName')) {
                        classNames.push(me.model.get('childClassName'));
                    }

                    widget.className = classNames.join(' ');
                }
            });

            const Region = RivalIQ.views.CompositeView.extend({
                childView: Section,
                childViewContainer: '.row',
                childViewOptions: function (model) {
                    return {
                        templateFn: model.get('templateFn')
                    };
                },
                className: function () {
                    const me = this;
                    return me.model.get('className');
                },
                template: function () {
                    return '<div class="row"/>';
                }
            });

            const Regions = RivalIQ.views.CollectionView.extend({
                childView: Region,
                childViewOptions: function (model) {

                    return {
                        className: 'export-padded-top',
                        collection: new Backbone.Collection(model.get('sections'))
                    };
                },

                // Filter out regions with all empty sections
                filter: function (child) {
                    const count = _.reduce(child.get('sections'), function (sum, section) {
                        return sum + section.collection.length;
                    }, 0);

                    return Boolean(count);
                }
            });

            const items = _.map(layout.getConfig(), function (region) {
                if (!_.has(region, 'sections')) {
                    const sections = (_.isArray(region) ? region : [region]);
                    region = {
                        sections: sections
                    };
                }

                _.each(region.sections, function (section) {
                    cache[section.name] = section.collection = new Backbone.Collection();
                });

                return region;
            });

            const regions = new Regions({
                collection: new Backbone.Collection(items)
            });

            regions.cache = cache;

            return regions;
        }
    });

    /**
     * Creates a layout class from config.
     * @param config The layout config
     */
    Layout.createFromConfig = function (config) {
        return views.Layout.extend({
            config: config
        });
    };

    function createWrapper(tagName, className) {
        const wrapper = document.createElement(tagName);
        wrapper.className = className;
        return wrapper;
    }

    /*
     * Sometimes for styling or other reasons we need to insert a node
     * inbetween a child view and its collection view. This happens most often
     * when rendering a bootstrap row. If we applied .col-sm-3 to the child,
     * and that child has a background (like a panel) there would be no gutter
     * rendered between children
     *
     * This method extends the provided collection view to attach an extra
     * element for each child. NOTE that it uses .extend, so any class specific
     * overrides will be clobbered.
     */
    function extendWidgetViewWithChildWrapper(wrapper, WidgetsView) {
        return WidgetsView.extend({
            wrapperTagName: wrapper.tagName || 'div',
            wrapperClassName: wrapper.className || '',

            _createBuffer: function () {
                const me = this;
                const elBuffer = document.createDocumentFragment();

                _.each(me._bufferedChildren, function (b) {
                    const wrapper = createWrapper(me.wrapperTagName, me.wrapperClassName);
                    wrapper.appendChild(b.el);
                    elBuffer.appendChild(wrapper);
                });

                return elBuffer;
            },

            attachHtml: function (collectionView, childView, index) {
                const me = this;
                if (!collectionView.isBuffering) {
                    const wrapper = createWrapper(me.wrapperTagName, me.wrapperClassName);
                    wrapper.appendChild(childView.el);
                    childView = {
                        el: wrapper
                    };
                }

                return Marionette.Dashboard.views.Widgets.prototype.attachHtml.call(collectionView, collectionView, childView, index);
            }
        });
    }
});
